
var id = "accountAuthority";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 128 128\" id=\"accountAuthority\">\n<path d=\"M125.3,90.3c-1.7-1.7-4.6-1.7-6.4,0.1L100.3,109c-1.8,1.8-4.7,1.8-6.5,0l-6.2-6.2c-1.8-1.8-4.7-1.8-6.4-0.1\n\tc-1.7,1.7-1.7,4.6,0.1,6.4l6.8,6.8c1.8,1.8,3.3,3.3,3.3,3.3s1.3,1.3,2.9,2.9c1.6,1.6,4.3,1.4,6.1-0.4l24.9-24.9\n\tC127,94.9,127.1,92,125.3,90.3z\" />\n<path d=\"M98,83.8c2.8,0,5.1-2.3,5.1-5.1c0-1.2-0.4-2.3-1.1-3.2c0,0-0.3-0.4-0.5-0.5c-0.2-0.2-0.5-0.4-0.7-0.6\n\tc-5.1-4-10.8-7.1-17-9.3c9.1-6.5,15.1-17.2,15.1-29.2C98.9,16.1,82.8,0,63,0C43.2,0,27.1,16.1,27.1,35.9c0,12.1,6,22.7,15.1,29.2\n\tC18.9,73.5,2.1,95.6,1.5,121.7c-0.1,0.4-0.1,0.7-0.1,1.1c0,2.9,2.3,5.2,5.2,5.2s5.2-2.3,5.2-5.2c0-0.1,0-0.2,0-0.3\n\tC12,94.5,34.9,71.8,63,71.8c12,0,31.8,10.9,31.8,10.9C95.7,83.4,96.8,83.8,98,83.8z M37.4,35.9c0-14.2,11.5-25.6,25.6-25.6\n\tc14.2,0,25.6,11.5,25.6,25.6C88.6,50,77.2,61.5,63,61.5C48.9,61.5,37.4,50,37.4,35.9z\" />\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
